'use client'

import {cx} from '@local/utils/cx'

import Logo from '@local/assets/svgs/logo-nav.svg'
import {Button} from '@local/ui/components'

export interface ComingSoonLogoProps {
	className?: string
	logoRef?
	asLink?: boolean
}

export const ComingSoonLogo = ({className, logoRef, asLink = false}: ComingSoonLogoProps) => {
	return (
		<Button
			as={!asLink && 'div'}
			href={asLink ? '/' : undefined}
			label={asLink ? 'Homepage Link' : undefined}
			className={cx(
				'fixed z-10 w-full h-auto flex justify-center mt-20 lg:mt-22 overflow-visible',
				className,
			)}>
			<span
				ref={logoRef}
				className='opacity-0 will-change-transform'>
				<Logo className='h-32 lg:h-40' role='presentation' />
			</span>
		</Button>
	)
}
